var map = {
	"./10_nuts.png": 2056,
	"./1drink_12beer.png": 2057,
	"./1serving_8ounces.png": 2058,
	"./1serving_8ounces2.png": 2059,
	"./1serving_8ounces3.png": 2060,
	"./1serving_8ounces4.png": 2061,
	"./1serving_8ounces5.png": 2062,
	"./8ounces_1glass.png": 2063,
	"./can_1.png": 2064,
	"./can_2.png": 2065,
	"./can_3.png": 2066,
	"./cup.png": 2067,
	"./dried_serving_1/4cup.png": 2068,
	"./dried_serving_1:4cup.png": 2069,
	"./fresh_serving_1cup.png": 2070,
	"./glass_1.png": 2071,
	"./glass_2.png": 2072,
	"./golfball.png": 2073,
	"./halfthumb.png": 2074,
	"./hand_1.png": 2075,
	"./hand_2.png": 2076,
	"./hand_3.png": 2077,
	"./hand_4.png": 2078,
	"./hand_5.png": 2079,
	"./how.png": 771,
	"./serving_1/2cup.png": 2080,
	"./serving_1:2cup.png": 2081,
	"./serving_1tbsp.png": 2082,
	"./serving_3/4ounces.png": 2083,
	"./serving_3:4ounces.png": 2084,
	"./thumbx2.png": 2085,
	"./usda.png": 2086,
	"./vegetables_1cup.png": 2087,
	"./what.png": 769,
	"./wholethumb.png": 2088,
	"./why.png": 770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2055;